import { StateChanges } from './stateChanges'
import { RunStates } from './runStates'
import router from '../router'

const basicMutations = {

  [StateChanges.SET_FOOTNOTE_RESULTS]: function (state, responseData) {
    state.footnoteApiResponse = responseData
  },
  [StateChanges.SET_TEXT_FOR_API_CALL]: function (state, newText) {
    state.textForApiCall = newText;
  },
  [StateChanges.SET_DATA_FOR_SYNOPSIS]: function (state, data) {
    state.dataForSynopsis = data;
  },
  [StateChanges.SET_DIRECT_RESULTS]: function (state, val) {
    state.directMatch = val
  },
  [StateChanges.SET_VISUALIZER]: function (state, val) {
    state.visualizerView = val;
  },
  [StateChanges.SET_MIN_RANGE]: function (state, val) {
    state.minRange = val;
  },
  [StateChanges.SET_MAX_RANGE]: function (state, val) {
    state.maxRange = val;
  },
  [StateChanges.SET_DATA]: function (state, newData) {
    //state.data = _.uniq(newData[0].data, 'baseMatchedText')
    //state.data = _.uniqBy(newData[0].data, v => [v.baseMatchedText, v.baseStartChar, v.baseTextLength, v.compTextLength].join())
    //console.log(state.data)
    state.data = newData[0].data
    state.numParallels = state.data.length
    if (router.currentRoute.name !== 'Results') {
      router.push({ name: 'Results' })
    }
  },
  [StateChanges.SET_FILE_TXT_RESULTS]: function (state, fileName) {
    state.txtFile = fileName.replace('Output', '')
  },
  [StateChanges.SET_FILE_DOC_RESULTS]: function (state, fileName) {
    state.docFile = fileName.replace('Output', '')
  },
  [StateChanges.SET_SYNOPSIS_FILE_RESULTS]: function (state, data) {
    state.synopsisFiles = data
  },
  [StateChanges.SET_SELECTED_RESULTS]: function (state, newData) {
    state.selectedResults = newData
  },
  [StateChanges.SET_SESSION_ID]: function (state, id) {
    state.sessionID = id
  },
  [StateChanges.SET_TALMUD_RESULTS]: function (state, newData) {
    state.talmudResults = newData;
  },
  [StateChanges.SET_MISHNA_RESULTS]: function (state, newData) {
    state.mishnaResults = newData;
  },
  [StateChanges.SET_TANAKH_RESULTS]: function (state, newData) {
    state.tanakhResults = newData;
  },
  [StateChanges.SET_MODE]: function (state, val) {
    state.mode = val;
  },
  [StateChanges.SET_VERSE_FOR_CHAPTER]: function (state, newData) {
    state.verseForChapter = newData
  },
  [StateChanges.SET_CHAPTER_RESULTS]: function (state, newData) {
    state.chapterResults = newData
  },
  [StateChanges.SET_VISUALIZER_MODE]: function (state, newData) {
    state.visualizerModes = newData
  },
  [StateChanges.SET_VISUALIZER_RESULTS]: function (state, val) {
    state.visualizerResults = val
  },
  [StateChanges.SET_NO_RESULTS]: function (state, val) {
    state.noResults = val;
  },
  [StateChanges.SET_HIGHER_THRESHOLD_RESULTS]: function (state, val) {
    state.higherResults = val;
  },
  [StateChanges.SET_LOWER_THRESHOLD_RESULTS]: function (state, val) {
    state.lowerResults = val;
  },
  [StateChanges.SET_EXTERNAL_TALMUD_RESULTS]: function (state, val) {
    state.extTalmudRes = val;
  },
  [StateChanges.SET_EXTERNAL_TANAKH_RESULTS]: function (state, val) {
    state.extTanakhRes = val;
  },
  [StateChanges.FOOTNOTES_NOT_RUN]: function (state) {
    state.serverState = RunStates.NOT_RUN
  },
  [StateChanges.FOOTNOTES_COMPLETE]: function (state) {
    state.serverState = RunStates.COMPLETE
  },
  [StateChanges.FOOTNOTES_RUNNING]: function (state) {
    state.serverState = RunStates.RUNNING;
  },
  [StateChanges.SERVER_FAILED]: function (state) {
    state.serverState = RunStates.FAILED
  },
  [StateChanges.SERVER_TIMED_OUT]: function (state) {
    state.serverState = RunStates.TIMED_OUT
  },
  [StateChanges.SYNOPSIS_RUNNING]: function (state) {
    state.synopsisServerState = RunStates.RUNNING
  },
  [StateChanges.SYNOPSIS_COMPLETE]: function (state) {
    state.synopsisServerState = RunStates.COMPLETE
  },
  [StateChanges.SYNOPSIS_SERVER_FAILED]: function (state) {
    state.synopsisServerState = RunStates.FAILED
  },
  [StateChanges.SYNOPSIS_SERVER_TIMED_OUT]: function (state) {
    state.synopsisServerState = RunStates.TIMED_OUT
  },
  [StateChanges.SET_SERVER_ERROR_MESSAGE]: function (state, msgObj) {
    state.serverMsgObj = msgObj
  }
}

export default basicMutations
